













import {Vue, Prop, Component } from 'vue-property-decorator'
import {LettersInDependencyGraph} from '@/store/models/Letter/DependencyTrail';
import * as persianDate from 'persian-date';
import * as util from '@/util/utils';
import * as $ from 'jquery';
import store from '@/store';

@Component
export default class DependencyGraphNode extends Vue{
    @Prop() nodeData?: LettersInDependencyGraph;

    get headerColor(){
        if(!this.nodeData)return 'gray';
        if(this.nodeData.enterpriseFormColor)
            return "#"+ this.nodeData.enterpriseFormColor.toString(16).substring(2).padStart(6,'0');
        return 'gray';
    }

    created(){
        //alert(this.headerColor);
        store.state.eventHub.$on("page-clicked",this.moveNode);
        store.state.eventHub.$on("unselect-all",this.unSelect);
        store.state.eventHub.$on("get-width",this.getWidth);
        store.state.eventHub.$on("set-position",this.setPosition);
        

    }

    unSelect(){
        this.isSelected = false;
    }

    moveNode(letterId: string, x: number , y: number){
        if(!this.nodeData)return;
        if(this.nodeData.letterId != letterId)return;
        //const width =  $(this.$refs.nodcontainer).css('width');
        //const height =  $(this.$refs.nodcontainer).css('height');
        $(this.$refs.nodcontainer).css('top',y);
        $(this.$refs.nodcontainer).css('left',x);
        this.isSelected = false;
        //$(this.$refs.nodcontainer).css('width',width);
        //$(this.$refs.nodcontainer).css('height',height);
    }

    get persDate(){
        if(this.nodeData)
             return util.getPersianDate(this.nodeData.letterDate,"YYYY/MM/DD");
        return '';
        
    }
    isSelected = false;
    onNodeDblClick(e: Event){
        e.stopPropagation();
        if(!this.nodeData)return;
        store.state.eventHub.$emit("unselect-all");
        this.$emit("dblclicked",this.nodeData.letterId);
        this.isSelected = true;
        //alert(( this.$refs.nodcontainer as any).clientWidth);
    }

    onNodeClick(e: Event){
        e.stopPropagation();
        if(!this.nodeData)return;
        const nodeInfo ={} as any;
        nodeInfo.letterNo = this.nodeData.letterNo;
        nodeInfo.letterId = this.nodeData.letterId;
        this.$emit("clicked",nodeInfo);
        
    }

    getWidth(letterId: string , level: number) {
        //alert("test");
        if(!this.nodeData)return;
        if(this.nodeData.letterId != letterId)return;
        if(!( this.$refs.nodcontainer as any))return;
        const width = ( this.$refs.nodcontainer as any).clientWidth;//$(this.$refs.nodcontainer).css('width');
        //alert(width);
        this.$emit('expose-width',width,level);
    }
    setPosition(letterId: string, x: number , y: number){
        if(!this.nodeData)return;
        if(this.nodeData.letterId != letterId)return;
        if(!( this.$refs.nodcontainer as any))return;
        $(this.$refs.nodcontainer).css('top',y);
        $(this.$refs.nodcontainer).css('left',x);
    }

    mounted(){
        this.$emit("node-mounted");
    }
}
